const ADDRESS_ABBREVIATIONS: Record<string, string> = {
  st: "street",
  str: "street",
  street: "street",

  rd: "road",
  road: "road",

  dr: "drive",
  drive: "drive",

  ave: "avenue",
  av: "avenue",
  avenue: "avenue",

  ln: "lane",
  lane: "lane",

  blvd: "boulevard",
  boulevard: "boulevard",

  ct: "court",
  court: "court",

  pl: "place",
  place: "place",

  cir: "circle",
  circle: "circle",

  hwy: "highway",
  highway: "highway",

  pkwy: "parkway",
  parkway: "parkway",

  ter: "terrace",
  terrace: "terrace",

  trl: "trail",
  trail: "trail",

  sq: "square",
  square: "square",

  loop: "loop",

  ext: "extension",
  extension: "extension",

  n: "north",
  s: "south",
  e: "east",
  w: "west",

  ne: "northeast",
  nw: "northwest",
  se: "southeast",
  sw: "southwest",
};

export const getAddressAbbreviationError = (
  value: string
): string | null => {
  if (!value) return null;

  const words = value
    ?.toLowerCase()
    ?.trim()
    ?.split(/\s+/);

  const found = words?.find(
    (word) =>
      ADDRESS_ABBREVIATIONS[word] &&
      word !== ADDRESS_ABBREVIATIONS[word]
  );

  if (found) {
    return `${found}: ${ADDRESS_ABBREVIATIONS[found]} not allowed`;
  }

  return null;
};